/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function AdminRetryStatisticsController(adminService) {
    var vm = this;
    vm.rows = [];
    vm.loading = true;

    adminService.getAllRetryStatistics().then(function(rows) {
        vm.rows = rows;
        vm.loading = false;
    }, function() {
        vm.loading = false;
    });
}



// WEBPACK FOOTER //
// ./src/app/admin/retry-statistics.controller.js